import {
  Card,
  Divider,
  Grid2,
  LinearProgress,
  Typography,
} from "@mui/material";

const NPSScoreWidget = ({
  score,
  totalResponders,
  monthWiseConsumedMessages,
  responseRatio,
  isMonth,
  type,
}) => {
  return (
    <Card
      className="card-admin"
      variant="outlined"
      sx={{
        boxShadow: 3,
        width: "100%",
        minHeight: "320px",
        p: "15px",
        background: "#1d2637",
        color: "white",
        borderRadius: "12px",
        fontFamily: "Montserrat, serif !important",
      }}
    >
      <Typography
        sx={{
          fontFamily: "Montserrat, serif !important",
          textTransform: "capitalize",
        }}
        variant="overline"
        gutterBottom
      >
        {`NPS (Net Promoter Score - ${type})`}
      </Typography>

      <Divider />
      <Typography
        variant="h4"
        gutterBottom
        sx={{ marginTop: "10px", fontFamily: "Montserrat, serif !important" }}
      >
        {Math.floor(score)}
      </Typography>

      <LinearProgress
        variant="buffer"
        value={score}
        valueBuffer={100}
        color="success"
        sx={{
          height: "30px",
          marginTop: "10px",
          // backgroundColor: "#e0e0e0",
          // color: "000",
          borderRadius: "2rem",
        }}
      />

      <Divider
        sx={{
          border: "1px solid  #ffffff75",
          marginTop: "1.7em",
          marginBottom: "1.7em",
        }}
      />

      <Grid2 container spacing={2} sx={{ m: "5px", marginTop: "0px" }}>
        <Grid2 size={{ xs: 12, md: isMonth ? 4 : 6 }} md={{ color: "white" }}>
          <Typography
            style={{ fontFamily: "Montserrat, serif !important" }}
            variant="overline"
            gutterBottom
          >
            Total Responses
          </Typography>
          <Typography
            variant="h4"
            gutterBottom
            sx={{
              marginTop: "2px",
              fontFamily: "Montserrat, serif !important",
            }}
          >
            {totalResponders}
          </Typography>
        </Grid2>
        <Grid2 size={{ xs: 12, md: isMonth ? 4 : 6 }} md={{ color: "white" }}>
          <Typography
            style={{ fontFamily: "Montserrat, serif !important" }}
            variant="overline"
            gutterBottom
          >
            Response Ratio
          </Typography>
          <Typography
            variant="h4"
            gutterBottom
            sx={{
              marginTop: "2px",
              fontFamily: "Montserrat, serif !important",
            }}
          >
            {responseRatio}%
          </Typography>
        </Grid2>
        {isMonth ? (
          <Grid2 size={{ xs: 12, md: 4 }} md={{ color: "white" }}>
            <Typography
              style={{ fontFamily: "Montserrat, serif !important" }}
              variant="overline"
              gutterBottom
            >
              Message Sent
            </Typography>
            <Typography
              variant="h4"
              gutterBottom
              sx={{
                marginTop: "2px",
                fontFamily: "Montserrat, serif !important",
              }}
            >
              {monthWiseConsumedMessages}
            </Typography>
          </Grid2>
        ) : null}
      </Grid2>
    </Card>
  );
};

export default NPSScoreWidget;
